import { toConsumableArray as _toConsumableArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Dots as Dots$2, Dot } from './MegaForm.styles.js';

var Dots = function Dots(_ref) {
  var _ref$numberOfDots = _ref.numberOfDots,
    numberOfDots = _ref$numberOfDots === void 0 ? undefined : _ref$numberOfDots,
    isLastStep = _ref.isLastStep,
    activeDot = _ref.activeDot;
  // Create an array that we can map over with n (numberOfDots) amount of elements
  var dots = _toConsumableArray(Array(numberOfDots).keys());

  // If numberOfDots is not defined, return the Styled.Dots styled wrapper
  // so that we maintain the spacing that we want but don't render the dots
  if (numberOfDots < 1 || typeof numberOfDots === 'undefined') return /*#__PURE__*/React.createElement(Dots$2, null);
  return /*#__PURE__*/React.createElement(Dots$2, {
    "data-testid": "dot-navigation"
  }, dots.map(function (dot, i) {
    return /*#__PURE__*/React.createElement(Dot, {
      key: dot,
      active: isLastStep ? numberOfDots === i + 1 : activeDot === i + 1
    });
  }));
};
var Dots$1 = Dots;

export { Dots$1 as default };
//# sourceMappingURL=Dots.js.map
